var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"battle-chip",attrs:{"to":{ name: 'Battle', params: { id: _vm.id } }}},[_c('div',{staticClass:"details"},[_vm._t("details")],2),_c('div',{staticClass:"additional-info"},[_vm._t("additional-info")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }